export enum ChannelListFilterType {
  All = 'All',
  Unread = 'Unread',
}
